export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";